module.exports = __webpack_public_path__ + "static/media/java.b855d7da.png";